import { useContext } from "react";
import { KycFileContext } from "../contexts/KycFileContext";

export const useKycFile = () => useContext(KycFileContext);
